module.exports = new __parcel__URL__("battleroyale_badge.79d0bdd1.png").toString();